import styled from "styled-components"
import { Link as GatsbyLink } from "gatsby"

import colors from "../utils/colors"

const Link = styled(GatsbyLink)<{ "data-gtm-cta": string }>`
  color: ${colors.teal};
`

export default Link
